import { GroupedMarketState } from './grouped-market-state';
import { GroupedMarketStats } from './grouped-market-stats';
import { GroupedMarketSupplier } from './grouped-market-supplier';

export class GroupedMarket {
	states?: GroupedMarketState[];
	suppliers?: GroupedMarketSupplier[];
	stats?: GroupedMarketStats;

	constructor(groupedMarket: GroupedMarket) {
		Object.assign(this, groupedMarket);
	}
}
